export default "__VITE_ASSET__CnHdYUQR__"